export class KeycloakUser {
    Vorname: string = '';
    Nachname: string = '';
    Email: string = '';
    Username: string = '';
    IstAuthentifiziert: boolean = false;
    Rollen: Array<string> = new Array<string>();
    Token: string = '';

    constructor(
        Vorname?: string,
        Nachname?: string,
        Email?: string,
        Username?: string,
        IstAuthentifiziert?: boolean,
        Rollen?: Array<string>,
        Token?: string,
    ) {
        this.Vorname = Vorname || '';
        this.Nachname = Nachname || '';
        this.Email = Email || '';
        this.Username = Username || '';
        this.IstAuthentifiziert = IstAuthentifiziert || false;
        this.Rollen = Rollen || new Array<string>();
        this.Token = Token || '';
    }
}
